import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Sokoni</h3>
            <p>
              Sokoni helps you convert your kredo to M-pesa/Airtel Money and buy cheap airtime. Our automated systems guarantee you speed and reliability.
            </p>
          </div>
          
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/convert">Convert Airtime to Cash</a></li>
              <li><a href="/buy-airtime">Buy Cheap Airtime</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Contact Us</h3>
            <p>
              Email: info@sokoni.co.ke<br />
              Phone: 0788866995
            </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Sokoni. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
